import { Button } from '@/components/Button';
import { useDownloadPdf } from '@/hooks/pdf.hooks';
import { twMerge } from 'tailwind-merge';

interface PdfDownloadButtonProps {
  text: string;
  filename: string;
  pdfModel: React.ReactNode;
  leftIcon?: React.ReactNode;
  buttonClassName?: string;
  textClassName?: string;
}

export const PdfDownloadButton = ({
  text,
  filename,
  pdfModel,
  leftIcon,
  buttonClassName,
  textClassName,
}: PdfDownloadButtonProps) => {
  const { downloadPdf, renderPdfModel } = useDownloadPdf();

  const handleDownload = async () => {
    try {
      await downloadPdf({ filename });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Button
        buttonClassName={twMerge(
          'bg-white h-[35px] border-1.5 border-gray-DCDFE8 dark-mode:bg-coal-500 dark-mode:border-gray-400',
          buttonClassName
        )}
        textClassName={twMerge(
          'text-light-inverse font-medium dark-mode:text-gray-600',
          textClassName
        )}
        text={text}
        leftIcon={leftIcon}
        onClick={handleDownload}
      />
      {renderPdfModel(pdfModel)}
    </>
  );
};
